// Name and vendor for product groups (altitudeGroups)
const altitudeGroups = [
    { id: 2, name: 'Turbulence CAT (World)', vendor: 'CAE' },
    { id: 4, name: 'EDR Turbulence Fcst (NAm)', vendor: 'CAE' },
    { id: 5, name: 'EDR Turbulence Fcst (World)', vendor: 'CAE' },
    { id: 6, name: 'Icing (NAm)', vendor: 'CAE' },
    { id: 7, name: 'Icing (World)', vendor: 'CAE' },
    { id: 8, name: 'Enhanced EDR Turbulence Fcst (NAm)', vendor: 'DTN' },
    { id: 9, name: 'Enhanced EDR Turbulence Fcst (World)', vendor: 'DTN' },
    { id: 10, name: 'FD Winds/Temps aloft (NAm)', vendor: 'HYD' },
    { id: 11, name: 'FD Winds/Temps aloft (World)', vendor: 'HYD' },
    { id: 12, name: 'Winds (World)', vendor: 'WSI' },
    { id: 13, name: 'GTG Turbulence (NAm)', vendor: 'WSI' },
    { id: 14, name: 'GTG Nowcast EDR Turbulence (NAm)', vendor: 'CAE' },
    { id: 15, name: 'Enhanced Icing Fcst-SmallAC (World)', vendor: 'DTN' },
    { id: 16, name: 'Enhanced Icing Fcst-MedAC (NAm)', vendor: 'DTN' },
    { id: 17, name: 'Enhanced Icing Fcst-MedAC (World)', vendor: 'DTN' },
    { id: 18, name: 'Enhanced Icing Fcst-LargeAC (NAm)', vendor: 'DTN' },
    { id: 19, name: 'Enhanced Icing Fcst-LargeAC (World)', vendor: 'DTN' },
    { id: 20, name: 'Winds/temps (World)', vendor: 'CAE' },
    { id: 21, name: 'Contrail regions', vendor: 'CAE' },
    { id: 22, name: 'Enhanced Icing Fcst-SmallAC (NAm)', vendor: 'DTN' },
    { id: 23, name: 'HIWC Fcst (World)', vendor: 'DTN' },
    { id: 24, name: 'London Volcanic Ash', vendor: 'CAE' }
] as const;

export type AltitudeGroup = (typeof altitudeGroups)[number];
export default Object.fromEntries(altitudeGroups.map((x) => [x.id, x]));
export const altitudeGroupsFlat = altitudeGroups;
